<template>
  <div
    :class="[{'layout-box':!inIframe}]"
    :style="layoutStyle"
  >
    <MyHeader v-if="!inIframe"></MyHeader>
    <div

      :style="{'min-height':contentheight}"
    >
      <div :class="[{content:!inIframe}]">
        <div :class="[{'section-content':!inIframe}]">
          <slot></slot>
        </div>
      </div>
    </div>
    <MyFooter v-if="!inIframe"></MyFooter>
  </div>
</template>
<script>
import MyHeader from '@/components/Layout/Header';
import MyFooter from '@/components/Layout/Footer';
import {inIframe} from '@/common/createMicroApp/utils';
export default {
  components: {
    MyHeader,
    MyFooter,
  },
  data() {
    return {
      contentheight: '',
      layoutStyle: {},
      inIframe,
    };
  },

  watch: {
    $route: {
      handler: function(){
        if (this.$route.name === 'productVersion'){
          this.layoutStyle.backgroundColor = '#fff';
        } else {
          this.layoutStyle.backgroundColor = '#f6f7fb';
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.$root.$on('layout-style',(layoutStyle)=>{
      this.layoutStyle = layoutStyle;
    });
  },
  mounted() {
    this.contentheight = `${window.innerHeight - 80 }px`;
  },
  beforeDestroy(){
    this.$root.$off('layout-style');
  },
  methods: {
  },
};
</script>


<style scoped lang="less">

.layout-box {
  background-color: #f6f7fb;
}
.content {
  padding: 20px 30px;
  // background-color: #fff;
}
.section-content {
  box-sizing: border-box;
  max-width: 1200px;
  margin: 0 auto;
  // background-color: #fff;
  // padding: 0 20px;
}
.ivu-layout-sider {
  background-color: #fff;
}
.sider {
  // background-color: #f3f3f3;
  /deep/ .ivu-menu-light {
    background-color: transparent;
  }
  /deep/ .ivu-menu-light::after {
    width: 0;
  }
  /deep/ .ivu-menu-light .ivu-menu-item-active::after {
    background-color: transparent;
  }
}
.breadcrumb-box {
  padding-bottom: 20px;

  /* /deep/ .ivu-breadcrumb{ */

  /*  font-size: 16px; */

  /* } */
}

</style>
